import React from 'react';
import cn from 'classnames';

import styles from './Header.module.scss';

export default function Header(props) {
  return (
    <div className={cn(styles.group1, 'header')}>
      <div className={styles.flex_row}>
        <div className={styles.flex_row__cell}>
          <img
            src={require('assets/e3854688dbfbf6a330359a4774e76e55.png')}
            alt="alt text"
            onClick={() => window.open('/Home', '_self')}
            className={styles.image}
          />
        </div>
        <div className={styles.flex_row__spacer} />
        <div className={styles.flex_row__cell1}>
          <div className={styles.flex_row1}>
            <h5 onClick={() => window.open('/Home', '_self')} className={styles.highlights}>
              Home
            </h5>
            <div className={styles.flex_row1__spacer} />
            <h5 onClick={() => window.open('/AboutUs', '_self')} className={styles.highlights1}>
              About
            </h5>
            <div className={styles.flex_row1__spacer} />
            <h5 onClick={() => window.open('#ContactUs', '_self')} className={styles.highlights2}>
              Contact
            </h5>
          </div>
        </div>
        <div className={styles.flex_row__spacer1} />
        <div className={styles.flex_row__cell2}>
          <div onClick={() => window.open('/Create', '_self')} className={styles.content_box}>
            <div className={styles.box1} />
            <h5 className={styles.highlights11}>Login</h5>
          </div>
        </div>
      </div>
    </div>
  );
}
